import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ErrorHandlingService} from '../common/error-handling.service';
import {Observable} from 'rxjs';
import {NotificationPushToken} from './notification-push-token.model';
import {
  CommonPaginationResponse,
  CommonResponse,
  PaginateResponse,
  processNormal,
  processPagination,
  VoidResponse
} from '../common/response.model';
import {environment} from '../../../../environments/environment';
import {catchError, map} from 'rxjs/operators';
import {Notification} from './notification.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  constructor(private http: HttpClient, private errorHandling: ErrorHandlingService) {
  }

  listPaginated(page): Observable<PaginateResponse<Notification[]>> {

    const params = new HttpParams().append('page', page);

    return this.http.get<CommonPaginationResponse<Notification[]>>(
      environment.apiUrl + 'user/notifications',
      {
        params
      }
    ).pipe(
      map(resp => processPagination(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }

  read(notificationId): Observable<VoidResponse> {

    return this.http.get<CommonResponse<VoidResponse>>(
      environment.apiUrl + 'user/notifications/' + notificationId + '/read'
    ).pipe(
      map(resp => processPagination(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }

  addPushToken(token): Observable<NotificationPushToken[]> {

    return this.http.post<CommonResponse<NotificationPushToken>>(
      environment.apiUrl + 'user/notifications/add-push-token',
      {
        platform: 'web',
        token
      }
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }

  deletePushToken(token): Observable<VoidResponse> {

    return this.http.post<CommonResponse<VoidResponse>>(
      environment.apiUrl + 'user/notifications/delete-push-token',
      {
        token
      }
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }
}
